import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY
const schema = import.meta.env.VITE_SUPABASE_SCHEMA || 'botanical'

export const hasSupabaseConfig = Boolean(supabaseUrl && publishableKey)

export const supabase = hasSupabaseConfig
  ? createClient(supabaseUrl, publishableKey, {
      db: { schema },
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null

export const botanicalSchema = schema
